<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card-text style="padding: 20px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  label="Número:"
                  v-model="data.item_number"
                  v-mask-number
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Nome:"
                  v-model="data.name"
                  :rules="fieldRules"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete
                  :items="[{ value: 'Nacional' }, { value: 'Importado' }]"
                  item-value="value"
                  item-text="value"
                  label="Origem:"
                  v-model="data.origem"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Marca:" v-model="data.marca" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Modelo:" v-model="data.modelo" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Validade"
                  v-model="data.validity"
                  v-mask-date.br
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Quantidade:"
                  v-model="data.quantidade"
                  v-mask-number
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Qtd. Mínima:"
                  v-model="data.qtd_minima"
                  v-mask-number
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Disponível:"
                  v-model="data.restante"
                  v-mask-number
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  :items="providers"
                  item-value="provider_id"
                  item-text="provider_name"
                  label="Participante:"
                  :rules="fieldRules"
                  v-model="data.provider_id"
                  append-icon="mdi-plus"
                  @click:append="
                    $router.push('/parts-and-services/providers-manager/create')
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
          >Confirmar</v-btn
        >
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import helpers from "@/mixins/helpers";
export default {
  props: ["b_id", "id"],
  mixins: [helpers],
  data: () => ({
    valid: false,
    loader: false,
    parts_and_services_type: [],
    providers: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      item_id: null,
      provider_id: null,
      prefecture_id: null,
      bidding_id: null,
      item_number: null,
      name: "",
      origem: null,
      marca: "",
      modelo: "",
      quantidade: null,
      restante: null,
      validity: "",
      qtd_minima: null,
    },
  }),
  created() {
    this.helpers;
    this.$http
      .get(`/parts-and-services/providers`)
      .then((r) => (this.providers = r.data));
    this.$http
      .get(`/parts-and-services/biddings/${this.b_id}`)
      .then((r) => (this.data.prefecture_id = r.data[0].prefecture_id));

    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http
        .post(`/parts-and-services/biddings/items/single/item/${this.id}`)
        .then((r) => {
          this.data = r.data[0];
          this.$store.dispatch("setLoader", false);
        });
    } else {
      this.data.bidding_id = Number(this.b_id);
    }
  },
  methods: {
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/parts-and-services/biddings/items/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push(
                `/parts-and-services/biddings-manager/edit/${this.data.bidding_id}`
              );
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.data.item_billing_price = this.data.item_price;
        this.$http
          .post("/parts-and-services/biddings/items", this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            setTimeout(() => {
              this.$router.push(
                `/parts-and-services/biddings-manager/edit/${this.data.bidding_id}`
              );
            }, 1500);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
